import * as yup from 'yup';

export const basicBehaviorValidationSchema = yup.object({
  minReplicas: yup
    .number()
    .min(1, 'Should be a positive value')
    .required('Required')
    .test('min-max-replicas', 'Min higher than max value', function (value) {
      const { maxReplicas } = this.parent;

      return (
        typeof value !== 'number' ||
        typeof maxReplicas !== 'number' ||
        value <= maxReplicas
      );
    }),
  maxReplicas: yup
    .number()
    .min(1, 'Should be a positive value')
    .required('Required')
    .test('max-min-replicas', 'Max lower than min value', function (value) {
      const { minReplicas } = this.parent;

      return (
        typeof value !== 'number' ||
        typeof minReplicas !== 'number' ||
        value >= minReplicas
      );
    }),
});
